const baseUrl = 'render_generations';

export class RenderGenerationsBffUrl {
  static create() {
    return baseUrl;
  }

  static show(id: string) {
    return `${baseUrl}/${id}`;
  }
}
